(ns web3.queries.service-provider
  (:require [x-vec.graphql :as x]
            [web3.persistence.queries :as q]
            [web3.queries.profile :as q-profile]))

(declare UUID! query fragment mutation String ID!)

(x/def ^fragment service-provider-fields {:on :ServiceProvider}
  q-profile/profile-fields
  :email
  :note
  :readOnly
  :iphonePhone
  :homePhone
  :otherPhone
  :createdAt
  :updatedAt)

(x/defn ^query service-provider [{:keys [^UUID! id]}]
        [:entity {:gql/alias-of :lookupEntity
                  :typeName "ServiceProvider"
                  :uuid id}
         q/entity-id-fields
         service-provider-fields])

(x/def ^fragment service-provider-mutation-fields {:on :ServiceProviderMutationPayload}
  [:property
   q/entity-id-fields
   [:serviceProviders
    q/entity-id-fields]]
  [:serviceProvider
   q/entity-id-fields
   service-provider-fields])

(x/defn ^mutation service-provider-update! [{:keys [^String companyName
                                                    ^String email
                                                    ^String firstName
                                                    ^String homePhone
                                                    ^ID! id
                                                    ^String iphonePhone
                                                    ^String lastName
                                                    ^String mobilePhone
                                                    ^String note
                                                    ^String officePhone
                                                    ^String otherPhone
                                                    ^String professionName
                                                    ^String website]}]
        [:serviceProvider_update {:companyName companyName
                                  :email email
                                  :firstName firstName
                                  :homePhone homePhone
                                  :id id
                                  :iphonePhone iphonePhone
                                  :lastName lastName
                                  :mobilePhone mobilePhone
                                  :note note
                                  :officePhone officePhone
                                  :otherPhone otherPhone
                                  :professionName professionName
                                  :website website}
         service-provider-mutation-fields])

(x/defn ^mutation service-provider-create! [{:keys [^String companyName
                                                    ^String email
                                                    ^String firstName
                                                    ^String homePhone
                                                    ^String iphonePhone
                                                    ^String lastName
                                                    ^String mobilePhone
                                                    ^String note
                                                    ^String officePhone
                                                    ^String otherPhone
                                                    ^String professionName
                                                    ^String website
                                                    ^ID! propertyId]}]
        [:serviceProvider_create {:companyName companyName
                                  :email email
                                  :firstName firstName
                                  :homePhone homePhone
                                  :iphonePhone iphonePhone
                                  :lastName lastName
                                  :mobilePhone mobilePhone
                                  :note note
                                  :officePhone officePhone
                                  :otherPhone otherPhone
                                  :professionName professionName
                                  :website website
                                  :propertyId propertyId}
         service-provider-mutation-fields])

(x/defn ^mutation service-provider-delete! [{:keys [^ID! id]}]
        [:serviceProvider_delete {:id id}
         service-provider-mutation-fields])

(x/defn ^query service-providers [{:keys [^UUID! id]}]
        [:entity {:gql/alias-of :lookupEntity
                  :typeName "Property"
                  :uuid id}
         [:... {:on :Property}
          q/entity-id-fields
          [:serviceProviders
           q/entity-id-fields
           service-provider-fields]]])